module.exports = __webpack_public_path__ + "img/min-margin-logo.f8dde875.svg";